const isObjectLike = value => value != null && typeof value === 'object'

export default isObjectLike
